export default "__VITE_ASSET__Bwf2pxAP__"